import { useState } from 'react';
import { Intent } from '@blueprintjs/core';
import { captureException } from '@sentry/browser';

import { AppToaster } from '@f/components/notification-toaster/AppToaster';

function showToast(message: string, intent: Intent, supplierType?: string) {
  AppToaster.show(
    {
      message,
      intent,
    },
    'SupplierError'
  );
}

export const useBaseSupplier = () => {
  const [isLoading, setLoading] = useState(false);

  const openSuppliers = async (suppliersLink?: string) => {
    setLoading(true);

    try {
      if (!suppliersLink) {
        showToast('No suppliers have been found.', Intent.WARNING);
        return;
      }

      window.open(suppliersLink as string, '_blank');
    } catch (error) {
      const toastMessage = error instanceof Error ? error.message : (error as string);
      showToast(toastMessage, Intent.DANGER);

      captureException(error);
    } finally {
      setLoading(false);
    }
  };

  return { isLoading, openSuppliers } as const;
};
